<div class="cl--header">
  <app-search-input [(query)]="search" placeholder="Search for cases" />
  <app-select [title]="'Sort by'" [selected]="sort()" [options]="sortOptions" />
</div>
<div class="cl--list" @casesListAnimation>
  @for (caseItem of filtered(); track $index) {
  <app-cases-case
    [caseItem]="caseItem"
    [balance]="sessionService.balanceType()"
  ></app-cases-case>
  } @empty { @if (casesService.casesList().length !== 0) {
  <div class="w-full flex flex-col gap-4 items-center absolute-center">
    <span class="typography-title">No cases found, try clearing search</span>
    <button
      class="button button--style-primary h-32 padding-x-12 rounded-4"
      (click)="search.set('')"
    >
      Clear search
    </button>
  </div>
  } }
</div>
